import PropTypes from 'prop-types';
// import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from 'components/common/tooltip';
// import { getBookingWidgetMultipropertyData } from 'features/multiproperty/MultipropertySlice';

const ReviewScoreFilter = ({ menuItems, onClick, selected }) => {
    // const multipropertyUrl = useSelector(
    //     (state) => state.miniBookingWidget?.data?.multipropertyUrl
    // );
    // const sortByProperty = useSelector((state) => state.user?.sortByProperty);
    // const dispatch = useDispatch();
    // const handleScoreReviewFilterClick = (value) => {
    //     const scoreFilter = '&scoreFilter=' + value;
    //     dispatch(
    //         getBookingWidgetMultipropertyData({
    //             multipropertyUrl,
    //             sortByProperty,
    //             scoreFilter,
    //         })
    //     );
    // };

    return (
        <Tooltip
            arrow
            interactive
            content={
                <div className="ab-review-score-filter-tooltip-content">
                    {menuItems.tooltipText}
                </div>
            }
            zIndex={100004}
            // trigger="click"
        >
            <div
                className={`ab-review-score-filter-single ${
                    selected && 'ab-review-score-filter-single--selected'
                }`}
                onClick={onClick}
            >
                {menuItems.text}
            </div>
        </Tooltip>
    );
};

ReviewScoreFilter.propTypes = {
    menuItems: PropTypes.object,
    onClick: PropTypes.func,
    selected: PropTypes.bool,
};

export default ReviewScoreFilter;
